import { useCallback, useContext } from "react"
import { CreateTestTakerContext } from "../CreateTestTakerContext"
import { useDispatch } from "react-redux"
import { initialize, reset } from "redux-form"

const useRestForm = () => {
    const { formname } = useContext(CreateTestTakerContext)
    const dispatch = useDispatch()

    const resetForm = useCallback(() => {
        dispatch(reset(formname))
        dispatch(initialize(formname, {}));
    }, [])

    return resetForm
}

export default useRestForm